import type { JSX } from 'react'

import { Icon, IconNames } from 'atoms/Icon'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/index'
import { ErrorMessageBackground } from './ErrorMessage.h'
import {
  ErrorMessageSC,
  ErrorMessageWrapperSC,
  ErrorText,
} from './ErrorMessage.styled'

export interface IErrorMessage {
  setRef?: (node: HTMLDivElement | null) => void
  color?: TextBoxColors
  background?: ErrorMessageBackground
  paddings?: FIXED_INDENTS[]
  title?: string
  font?: TextBoxTypes
  icon?: IconNames
  iconPosition?: 'left' | 'right'
  width?: string
  maxLines?: number
  warning?: boolean
  position?: string
  zIndex?: number
}

export const ErrorMessage = ({
  setRef,
  color = TextBoxColors.TEXT_ICON_CONSTANT_LIGHT,
  background = ErrorMessageBackground.ADDITIONAL_RED_2,
  paddings = [FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_60],
  title,
  font = TextBoxTypes.Body3,
  icon = IconNames.info,
  width,
  iconPosition,
  maxLines = 2,
  warning = false,
  zIndex,
}: IErrorMessage): JSX.Element => {
  const textColor = warning ? TextBoxColors.TEXT_ICON_CONSTANT_DARK : color

  return (
    <ErrorMessageWrapperSC zIndex={zIndex}>
      <ErrorMessageSC
        ref={setRef}
        colorDefault={textColor}
        background={
          warning ? ErrorMessageBackground.ADDITIONAL_ORANGE : background
        }
        paddings={paddings}
        width={width}
        iconPosition={iconPosition}
      >
        <ErrorText>
          <Icon name={icon} />
          <TextBox
            title={title}
            color={textColor}
            font={warning ? TextBoxTypes.FontSm : font}
            maxLines={maxLines}
          />
        </ErrorText>
      </ErrorMessageSC>
    </ErrorMessageWrapperSC>
  )
}
